export const siteNav = [
  { label: "首页", key: "home" },
  { label: "独家", key: "exclusive" },
  { label: "深挖现场", key: "dig" },
  { label: "复盘特稿", key: "review" },
  { label: "起底时间线", key: "timeline" },
  { label: "档案库", key: "archive" },
];

export const channelSeries = [
  { name: "复盘档案", desc: "把事件拆到骨头，还原每一处因果", count: 128 },
  { name: "时间线还原", desc: "按分钟复原现场，看关键节点如何滚雪球", count: 96 },
  { name: "关系链图谱", desc: "抽丝剥茧，厘清背后的人与组织脉络", count: 74 },
  { name: "未公开细节", desc: "采访手记里那些没说出口的部分", count: 61 },
  { name: "起底特稿", desc: "长文重场，一次讲透一整件事", count: 88 },
];

export const heroLead = {
  tag: "独家 · 深挖",
  kicker: "独家调查 · 编辑部万字长文",
  title: "一份流向不明的「城市共建金」：三年、四家公司与一张从未公开的审批表",
  summary:
    "我们回溯了 300 余份文书与 11 位相关人士的访谈记录，试图还原一笔专项资金从立项、流转到去向不明的完整链条。中间至少有三处本可被拦截的节点，最终都因为「程序合理」而被轻轻放过。",
  author: "记者 林深",
  date: "2026.09.05",
  readtime: "约 26 分钟阅读",
  heat: "12.4w 阅读",
  comments: "3,209",
};

export const heroStacks = [
  {
    tag: "复盘",
    title: "一场「口碑崩盘」是如何在 48 小时内发生的：复盘某新消费品牌的失控时刻",
    meta: "复盘特稿 · 9 分钟",
    img: "https://readdy.ai/api/search-image?query=moody%20editorial%20photo%20of%20a%20cluttered%20creative%20office%20at%20dusk%2C%20deep%20vermillion%20and%20warm%20ink%20tones%2C%20film%20grain%2C%20low%20key%20cinematic%20lighting%2C%20dark%20textured%20background%2C%20documentary%20journalism%20aesthetic&width=900&height=600&seq=stack-a&orientation=landscape",
  },
  {
    tag: "时间线",
    title: "起底：那个被反复转发的「内部通知截图」，最早从哪个群流出",
    meta: "时间线还原 · 6 分钟",
    img: "https://readdy.ai/api/search-image?query=dark%20noir%20photography%20of%20hands%20typing%20on%20an%20old%20telephone%20and%20paper%20documents%2C%20deep%20red%20and%20ink%20black%20tones%2C%20heavy%20film%20grain%2C%20moody%20low%20key%20light%2C%20investigative%20documentary%20style&width=900&height=600&seq=stack-b&orientation=landscape",
  },
];

export const heroSmalls = [
  {
    tag: "关系链",
    title: "同一栋楼里注册的 7 家公司，都指向一个从未露面的法人",
  },
  {
    tag: "未公开细节",
    title: "采访对象删掉的最后一句话，往往才是答案",
  },
];

export const editorial = {
  eyebrow: "本期起底 · 封面特稿",
  title: "「无主」的公益拍卖：成交价翻了三倍，善款却迟迟没有下文",
  standfirst:
    "一场名义上的公益拍卖，落槌价比起拍价高出三倍。主办方反复强调「专款专用」，可公开渠道里，善款的去向始终查无实证。我们花了 40 天，把竞买规则、保证金账户与后续公示逐条对照，发现账目里的「缺口」不止一处。",
  pullquote: "在很多环节，「合规」只是免于追责的说法，而不是真的交代了钱的去向。",
  byline: "本刊记者 陈砚 · 摄影 周野",
  meta: ["深度报道", "财新观察", "调查手记"],
};

export const rankings = [
  {
    rank: "01",
    title: "起底「会员制内容付费」背后的拉人头结构：谁在为谁埋单",
    snippet: "层层返佣的链条里，最底层用户的数据被反复转卖，而主导者几乎隐形。",
    heat: 98234,
    tag: "商业起底",
  },
  {
    rank: "02",
    title: "一份「试用期」劳动合同：三个字，让三百名员工没了补偿",
    snippet: "同批入职、同批离职，法院卷宗里出现了几乎一模一样的答辩词。",
    heat: 85671,
    tag: "劳动观察",
  },
  {
    rank: "03",
    title: "网红孵化机构的三份合同：直播间热闹，账本却各自为政",
    snippet: "流量、分账、违约金——三方博弈里，只有算法稳赚不赔。",
    heat: 73452,
    tag: "新经济",
  },
  {
    rank: "04",
    title: "「自动续费」的最后一秒：为何总在零点前悄悄扣款",
    snippet: "用不明显的字号与逆向勾选，把退订做成一场耐力赛。",
    heat: 61908,
    tag: "消费维权",
  },
  {
    rank: "05",
    title: "起底一家「卖课总部」：楼是租的，案例是抄的，学员是共享的",
    snippet: "门牌换了三次，讲师团队仍是同一批人，换了张海报而已。",
    heat: 50442,
    tag: "行业乱象",
  },
];

export const timeline = {
  topic: "起底时间线 ·「退款即拉黑」事件",
  subtitle: "从第一条差评到平台出面，一共 79 个小时。我们把这 79 个小时按分钟还原。",
  nodes: [
    { time: "09:12", title: "第一条真实差评出现", desc: "一位老用户晒出运费明细，评论区半小时内涌入 200+ 相似经历。" },
    { time: "11:40", title: "客服开始批量「安抚」", desc: "话术模板连夜更新，关键词从「解释」变成了「补偿优惠券」。" },
    { time: "15:05", title: "负面内容被集中折叠", desc: "多篇长评在无系统提示的情况下被移动至折叠区，排序被打乱。" },
    { time: "22:30", title: "用户自发整理证据帖", desc: "有人把两年内的订单记录做成了长图，在站外开始快速传播。" },
    { time: "次日 14:00", title: "官方发布首份回应", desc: "通稿只谈「功能升级」，全程回避退款与数据两个核心问题。" },
    { time: "次日 22:00", title: "媒体与平台介入", desc: "事件进入公开讨论议程，原始差评被重新置顶。" },
  ],
};

export const relations = {
  title: "关系链图谱 · 拆解「一个项目为何绕过三道审批」",
  intro:
    "把公开登记信息与访谈交叉比对后，我们整理出这条被刻意打散的关系链。虚线表示「无书面关联，但有强间接证据」。",
  pairs: [
    { left: "中标方 A 公司", rel: "同一电话登记", right: "招标代理 B 事务所" },
    { left: "招标代理 B 事务所", rel: "法人系亲属", right: "评审专家 C" },
    { left: "评审专家 C", rel: "曾在 D 供职", right: "监管方 D 集团前员工" },
    { left: "监管方 D 集团", rel: "间接持股", right: "材料供应 E 厂" },
  ],
  footnote: "说明：以上关系均来自公开工商与访谈交叉比对，未经当事人回应前暂不构成结论性指控。",
};

export const archives = [
  {
    size: "large",
    tag: "复盘特稿",
    title: "三地分公司账目几乎相同：复盘一家「成长神话」如何用同一套报表走了五年",
    excerpt: "换了城市、换了项目，唯独利润表的数字结构从未变过。",
    img: "https://readdy.ai/api/search-image?query=editorial%20documentary%20photography%20of%20stacks%20of%20paper%20financial%20documents%20and%20a%20magnifying%20glass%2C%20deep%20vermillion%20and%20warm%20ink%20tones%2C%20film%20grain%2C%20dark%20cinematic%20low%20key%20lighting%2C%20textured%20background&width=1200&height=760&seq=arch-1&orientation=landscape",
    meta: "19 分钟 · 1.8w 阅读",
  },
  {
    size: "small",
    tag: "独家",
    title: "独家：那份流出的「排期表」比官方口径提前了整整一个季度",
    excerpt: "落款时间、版本号与公开说法的矛盾，指向一个更早的决策时点。",
    meta: "5 分钟",
  },
  {
    size: "small",
    tag: "起底",
    title: "同一套宣传照，被四家机构重复使用了两年",
    excerpt: "摄影棚背景里的细节，比声明更有说服力。",
    meta: "7 分钟",
  },
  {
    size: "small",
    tag: "未公开细节",
    title: "录音里的 30 秒沉默：被剪掉的往往是关键",
    excerpt: "一次还原原始素材的采访手记。",
    meta: "8 分钟",
  },
  {
    size: "large",
    tag: "关系链",
    title: "从一条招聘广告反推出一整张「影子团队」",
    excerpt: "岗位描述里的内部黑话，把两家本无交集的注册公司串在了一起。",
    img: "https://readdy.ai/api/search-image?query=moody%20documentary%20photograph%20of%20an%20empty%20open%20office%20floor%20with%20desks%20and%20a%20dark%20window%2C%20deep%20red%20and%20black%20tones%2C%20film%20grain%2C%20low%20key%20cinematic%20lighting%2C%20investigative%20atmosphere&width=1200&height=760&seq=arch-2&orientation=landscape",
    meta: "14 分钟 · 9.6k 阅读",
  },
];

export const discussions = {
  topic: "热议现场 ·「自动续费」与「退款难」，你被哪家坑过",
  summary: "本期话题累计 4,812 条评论，以下是按认同数排序的热评摘录。",
  comments: [
    {
      name: "匿名调查员",
      tag: "高赞",
      agree: 1284,
      text: "最气人的不是扣款，是它永远把退订入口藏在你不会去看的地方。投诉要花三十分钟，退订只要三步——设计得如此不对称，本身就是一种恶意。",
    },
    {
      name: "南方某市居民",
      agree: 967,
      text: "我是那条 79 小时时间线里被折叠差评的作者之一。折叠当天没有人通知我，后台连个系统消息都没有。感谢黑料社把它挖出来。",
    },
    {
      name: "前运营从业者",
      agree: 755,
      text: "行业内把这叫「沉默流失」。从产品视角看一切都合规，但从用户视角看就是骗局。两边都在骂，说明这事其实没有灰色地带。",
    },
    {
      name: "普通读者",
      agree: 431,
      text: "希望这类起底能常态化，不用每次等舆论爆炸才有人管。深度复盘比碎片快讯有用得多，你们要继续做下去。",
    },
  ],
};

export const manifesto = {
  title: "关于黑料社",
  body: "黑料社是一个专注「完整复盘」的深度内容档案。我们不追碎片化的即时爆料，而是用特稿的方式把时间线、人物关系与未公开细节摊开重讲。每篇起底都经多源交叉核对，正文与结论分开呈现，欢迎理性的质疑与补充。",
};

export const footLinks = [
  { group: "栏目", items: ["独家", "深挖现场", "复盘特稿", "起底时间线", "档案库"] },
  { group: "关于", items: ["编辑部", "免责声明", "供稿与线索", "转载合作", "联系我们"] },
];